// @flow strict

import * as React from 'react'
import { Link as GatsbyLink } from 'gatsby'

import styles from './Link.module.scss'

/*******************************************************************************
  Types
 ******************************************************************************/

export type Props = {
  children: React.Node,
  href?: string,
  as?: React.Element<typeof GatsbyLink>,
  active?: boolean,
}

/*******************************************************************************
  Component
 ******************************************************************************/

const Link = (props: Props) => {
  const { href, children, as, active = false } = props
  const className = active ? styles.active : styles.link

  if (!as) {
    return (
      <a href={href} className={className}>
        {children}
      </a>
    )
  }

  return React.cloneElement(as, { className }, children)
}

export default Link
